import React, { useState, useEffect } from "react";
import axios from "axios";
import "../styles/Profile.css";

const API_BASE_URL = process.env.REACT_APP_API_URL || "https://depotaircerdas.com/api";

const Profile = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const username = localStorage.getItem("username");
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!username || !token) {
      window.location.href = "/login";
      return;
    }

    const fetchProfile = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/profile/${username}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        setProfile(res.data);
      } catch (err) {
        console.error("❌ Error fetching profile:", err);
        setError("Gagal mengambil data profil. Periksa koneksi atau token.");
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [username, token]);

  const handleLogout = () => {
    localStorage.removeItem("username");
    localStorage.removeItem("token");
    localStorage.removeItem("is_super_admin");
    window.location.href = "/login";
  };

  return (
    <div className="page-shell">
      <div className="page-hero-card">
        <span className="page-hero-badge">Akun Pengguna</span>
        <h2 className="page-hero-title">Profil</h2>
        <p className="page-hero-subtitle">
          Lihat informasi akun yang sedang aktif dan kelola sesi login Anda dengan
          tampilan yang lebih rapi dan nyaman.
        </p>
      </div>

      {loading ? (
        <div className="profile-state-box">Memuat data profil...</div>
      ) : error ? (
        <div className="profile-state-box error">{error}</div>
      ) : profile ? (
        <div className="profile-layout-grid">
          <section className="page-card">
            <div className="page-card-header">
              <div>
                <h3 className="section-title">Informasi Profil</h3>
                <p className="section-subtitle">Data utama akun yang sedang digunakan.</p>
              </div>
            </div>

            <div className="profile-info-grid">
              <div className="profile-info-card">
                <span>Username</span>
                <strong>{profile.username}</strong>
              </div>

              <div className="profile-info-card">
                <span>Nama Depot / Rumah</span>
                <strong>{profile.depot_name || "Tidak Tersedia"}</strong>
              </div>

              <div className="profile-info-card full">
                <span>Alamat</span>
                <strong>{profile.address || "Tidak Tersedia"}</strong>
              </div>
            </div>
          </section>

          <section className="page-card profile-side-card">
            <div className="profile-avatar-box">
              <div className="profile-avatar-circle">
                {(profile.username || "U").charAt(0).toUpperCase()}
              </div>
              <h3>{profile.depot_name || profile.username}</h3>
              <p>@{profile.username}</p>
            </div>

            <div className="profile-action-box">
              <button className="logout-modern-btn" onClick={handleLogout}>
                Logout
              </button>
            </div>
          </section>
        </div>
      ) : (
        <div className="profile-state-box">Data profil tidak tersedia.</div>
      )}
    </div>
  );
};

export default Profile;